import React from 'react'

import { HiCheckCircle } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

// Shared chrome for selectable rows (user pickers, channel rows) so the
// selected affordance stays in lockstep across surfaces.
export const selectableRowClass = (selected: boolean, className?: string) =>
  twMerge(
    'flex w-full items-center gap-2 rounded-md border p-2 shadow-sm transition-colors',
    selected
      ? 'border-accent-300 bg-accent-50 dark:border-accent-500/40 dark:bg-accent-500/15'
      : 'border-primary-200 bg-white hover:bg-primary-50 dark:border-primary-700 dark:bg-default-dark dark:hover:bg-primary-800/40',
    className,
  )

export const selectableRowTitleClass = (
  selected: boolean,
  className?: string,
) =>
  twMerge(
    'truncate text-[13px] font-medium',
    selected
      ? 'text-accent-900 dark:text-accent-100'
      : 'text-primary-900 dark:text-primary-100',
    className,
  )

interface SelectionIndicatorProps {
  selected: boolean
}

export const SelectionIndicator: React.FC<SelectionIndicatorProps> = ({
  selected,
}) =>
  selected ? (
    <HiCheckCircle className="h-5 w-5 shrink-0 text-accent-600 dark:text-accent-300" />
  ) : (
    <span className="h-5 w-5 shrink-0 rounded-full border-[1.5px] border-primary-300 dark:border-primary-600" />
  )
